import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} Birds Paradise. All rights reserved.</p>
        <p>
          Follow us on: 
          <a href="https://facebook.com" target="_blank" rel="noreferrer"> Facebook </a> | 
          <a href="https://instagram.com" target="_blank" rel="noreferrer"> Instagram </a> | 
          <a href="https://twitter.com" target="_blank" rel="noreferrer"> Twitter </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;

